import BaseService from '@/api/services/index'
import { Status } from '@/api/models/Status'
import Store from '@/api/models/store/Store'
import CdekCity from '@/api/models/CdekCity'
import { TariffGroup } from '@/api/models/TariffGroup'
import Package from '@/api/models/Package'
import { ProductProperty } from '@/models/ProductProperty';

const PREFIX = 'api_front_v1_reference_'

export default class ReferenceService extends BaseService {
    public async getSystemStatusesList (): Promise<Array<Status>> {
        const response = await this.api.get<never, Array<Status>>(
            this.getUrl('get_system_statuses', {}, PREFIX)
        )
        return response.data
    }

    public async getCdekStatusesList (): Promise<Array<Status>> {
        const response = await this.api.get<never, Array<Status>>(
            this.getUrl('get_cdek_statuses', {}, PREFIX)
        )
        return response.data
    }

    public async getSystemProductStatusesList (): Promise<Array<Status>> {
        const response = await this.api.get<never, Array<Status>>(
            this.getUrl('get_system_product_statuses', {}, PREFIX)
        )
        return response.data
    }

    public async getSystemPaymentStatusesList (accountId: number): Promise<Array<Status>> {
        const response = await this.api.get<never, Array<Status>>(
            this.getUrl('get_system_payment_statuses', { accountId: accountId }, PREFIX)
        )
        return response.data
    }

    public async getSystemStores (): Promise<Array<Store>> {
        const response = await this.api.get<never, Array<Store>>(
            this.getUrl('get_stores', {}, PREFIX)
        )
        return response.data
    }

    public async getCdekCities(cityPattern: string): Promise<Array<CdekCity>> {
        const response = await this.api.get<unknown, Array<CdekCity>>(
            this.getUrl(
                'get_cdek_cities',
                { city: cityPattern },
                PREFIX
            )
        )
        return response.data
    }

    public async getCdekCityByCityCode(code: number): Promise<CdekCity> {
        const response = await this.api.get<unknown, CdekCity>(
            this.getUrl(
                'get_cdek_city',
                { code },
                PREFIX
            )
        )
        return response.data
    }

    public async getAllTariffs(): Promise<Array<TariffGroup>> {
        const response = await this.api.get<unknown, Array<TariffGroup>>(this.getUrl('get_all_tariffs', {}, PREFIX))

        return response.data
    }

    public async getCdekPackages(): Promise<Array<Package>> {
        const response = await this.api.get<unknown, Array<Package>>(this.getUrl('get_cdek_packages', {}, PREFIX))

        return response.data
    }

    public async getProductProperties(accountId: number): Promise<Array<ProductProperty>> {
        const response = await this.api.get<unknown, Array<ProductProperty>>(
            this.getUrl('product_properties', { accountId: accountId }, PREFIX)
        )

        return response.data
    }
}
